import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function LoginScreen() {
  const { login, signingIn, authError, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  async function handleLogin() {
    try {
      await login();
    } catch (err) {
      if (err.code === 'ACCESS_DENIED') {
        navigate('/access-denied');
      }
    }
  }

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-5 px-6
                 bg-gradient-to-b from-primary-dark to-primary"
    >
      <span className="text-7xl drop-shadow-lg select-none" aria-hidden>₹</span>

      <div className="text-center">
        <h1 className="text-2xl font-bold text-white leading-tight">
          ₹ Namma<span className="text-blue-300">Expense</span>Tracker
        </h1>
        <p className="text-sm text-blue-200 mt-1">Our family's private expense tracker</p>
      </div>

      <div className="w-full max-w-sm bg-white rounded-card shadow-xl p-6 flex flex-col gap-4">
        {authError && !authError.code && (
          <p className="text-danger text-sm text-center bg-red-50 rounded p-2">
            {authError.message}
          </p>
        )}

        <button
          onClick={handleLogin}
          disabled={signingIn}
          aria-label="Sign in with Google"
          className="flex items-center justify-center gap-3 w-full border border-gray-300
                     rounded-input py-3 text-sm font-semibold text-gray-700
                     hover:bg-gray-50 disabled:opacity-60 transition-colors"
        >
          {/* Google SVG logo */}
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {signingIn ? 'Signing in…' : 'Sign in with Google'}
        </button>

        <p className="text-xs text-gray-400 text-center">
          🔒 Private Access
        </p>
      </div>
    </div>
  );
}
